<template>
  <div class="userInfo">
    <!-- 个人资料-->
    <div class="userInfo-title">{{$t('userinfo.personaldata')}}</div>
    <!-- 头像-->
    <div class="avatar">
      <div class="avatar-avatar"
           @mouseleave="editAvatar"
           @mouseenter="editAvatar">
        <!-- 显示的头像-->
        <img class="avatar-img" :src="form.avatar">
        <!-- 鼠标移入 编辑头像 -->
        <el-upload
            v-if="showEditAvatar"
            class="avatar-avatar"
            action="/api/file/upload"
            :show-file-list="false"
            :accept="acceptType"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
          <div class="avatar-editImg">
            <img :src="`${$g.imgPrefix}/img/userInfo/edit.svg`">
          </div>
        </el-upload>
      </div>
      <!-- 点击图片进行编辑-->
      <div class="avatar-text">{{$t('userinfo.clickimage')}}</div>
    </div>
    <el-form :model="form" ref="formRef" class="operate">
      <!-- 昵称-->
      <div class="operate-box">
        <div class="operate-title">{{$t('userinfo.nickname')}}</div>
        <div v-if="!editNickName" class="operate-before">
          <div class="operate-before-name">{{ form.name }}</div>
          <!-- 编辑-->
          <div class="edit" @click="editItem('editNickname')">{{$t('userinfo.edit')}}</div>
        </div>
        <editNickname
            ref="editNickname"
            @refreshInfo="refreshInfo(arguments,'editNickName')" />
      </div>
      <!-- 登录邮箱-->
      <div class="operate-box">
        <!-- AlongShare登录邮箱-->
        <div class="operate-title">{{$t('userinfo.alongshareloginemail')}}</div>
        <div class="operate-before">
          <div class="operate-before-name">{{ form.email }}</div>
        </div>
      </div>
      <!-- 重设密码-->
      <div class="operate-box">
        <!-- 重设密码-->
        <div class="operate-title">{{$t('userinfo.resetpassword')}}</div>
        <div v-if="!editPassword" class="operate-before">
          <!-- 编辑密码-->
          <div class="operate-before-name">{{$t('userinfo.editpassword')}}</div>
          <!-- 编辑-->
          <div class="edit" @click="editItem('resetPassword')">{{$t('userinfo.edit')}}</div>
        </div>
        <resetPassword
            ref="resetPassword"
            @refreshInfo="refreshInfo(arguments,'editPassword')" />
      </div>
    </el-form>
  </div>
</template>

<script>
import {
  getUserInfo,
  MessageSuccess,
  MessageError,
  isEmpty,
  formatObj
} from "@/util/util";
import {
  getUserByid,
  updateUserById
} from "@/request/requests"
import editNickname from "@/views/modules/puserinfo/editNickname";
import resetPassword from "@/views/modules/puserinfo/resetPassword";
export default {
  name: "puserinfo",
  components:{
    editNickname,
    resetPassword
  },
  data() {
    return {
      showEditAvatar: false,
      acceptType: '.jpg,.png,.jpeg',
      editNickName: false,
      editPassword: false,
      defaultAvatar: `${$g.imgPrefix}/img/header/Group1000005849@2x.webp`,
      form: {
        //头像
        avatar: '',
        //昵称
        name: '',
        //邮箱
        email:'',
        //当前密码
        password: '',
        //新密码
        newPassword: '',
        //确认密码
        confirmPassword: ''
      },
      userinfo:""
    }
  },
  computed:{
    disabledUpdateName(){
      let flag = true;
      if(!this.isEmpty(this.form.name)){
        flag = false;
      }
      return flag;
    },
  },
  methods: {
    isEmpty,
    refreshInfo(params,editFlag){
      console.log(params);
      this[editFlag] = false;
      this.getUserByidInfo();
    },
    async getUserByidInfo(){
      let res = await getUserByid(this.userinfo.id)
      if (res.status == "200") {
        //头像
        if (this.isEmpty(res.data.avatar)){
          this.form.avatar = this.defaultAvatar;
        }else{
          this.form.avatar = res.data.avatar;
        }
        this.form.name = res.data.name;
        this.form.email = res.data.email;
      } else {
        MessageError(res.msg)
      }
    },
    async saveData(obj) {
      let params = formatObj(obj);
      let res = await updateUserById(params)
      if (res.status == "200") {
        this.getUserByidInfo();
        MessageSuccess(res.msg)
      } else {
        MessageError(res.msg)
      }
    },
    editItem(flag) {
      this.$nextTick(()=>{
        this.$refs[flag].init(formatObj(this.form));
      })
    },
    editAvatar() {
      this.showEditAvatar = !this.showEditAvatar;
    },
    handleAvatarSuccess(res, file) {
      if (res.status == "200") {
        this.form.avatar = res.data;
        let params = {
          avatar: this.form.avatar
        }
        this.saveData(params)
      } else {
        MessageError(res.msg)
      }
      console.log(file)
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || 'image/png';
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        // this.$message.error('Uploaded pictures can only be in JPG | png format');
        // this.$message.error('업로드된 사진은 JPG | png 형식만 가능합니다.');
        this.$message.error(this.$t('userinfo.onlyjpgpng'));
      }
      if (!isLt5M) {
        // this.$message.error('The size of the uploaded image cannot exceed 5MB!');
        // this.$message.error('업로드된 이미지의 크기는 5MB를 초과할 수 없습니다!!');
        this.$message.error(this.$t('userinfo.cannotexceed'));
      }
      return isJPG && isLt5M;
    },

  },
  mounted(){
    let userInfo = getUserInfo();
    if (userInfo) {
      this.userinfo = JSON.parse(userInfo);
      this.getUserByidInfo();
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/userInfo.scss";
</style>